//Lib
import { FieldType, ViewModelBase, ApiResult } from "@shoothill/core";
import { action, computed, observable, runInAction } from "mobx";

// App
import { AppUrls } from "AppUrls";
import { StoresInstance } from "Globals/Stores";
import { SaveStore } from "Globals/Stores/Domain";

// Models
import { CreditReportDTO } from "Globals/Models/DTO/CreditReportDTO";
import { UserFile } from "Globals/Models/UserFile";
import { CreditReportModel } from "Globals/Models/Domain/FormSections/CreditReport/CreditReportModel";

// View models
import ParentCreditReportViewModel from "./ParentCreditReportViewModel";

export default class CreditReportViewModel extends ViewModelBase<CreditReportModel> {
    private saveStore: SaveStore = StoresInstance.Domain.SaveStore;

    constructor(creditReportModel?: CreditReportModel) {
        super(creditReportModel ? creditReportModel : new CreditReportModel());
    }

    @action
    public save = async (userFile: UserFile, parent: ParentCreditReportViewModel, isDeleted: boolean = false): Promise<void> => {
        try {
            let valid = await this.isModelValid();
            if (isDeleted || valid) {
                this.setIsLoading(true);
                this.saveStore.setIsSaving(true);

                runInAction(() => {
                    this.model.formId = parent.model.formId;
                    this.model.applicantId = parent.model.applicantId;
                    this.model.creditFileName = userFile.fileName;
                    this.model.creditDocumentUrl = userFile.fileUrl;
                    this.model.isDeleted = isDeleted;
                });

                let upsertCreditReport: CreditReportDTO = this.model.toDto();
                const apiResult = await this.Post<CreditReportDTO>(AppUrls.Server.ApplicationForm.Upsert.CreditReport, upsertCreditReport);

                if (apiResult.wasSuccessful) {
                    this.model.fromDto(apiResult.payload);
                    console.info("CreditReport:Upsert-Successful");

                    let armedForcesProofModel = new CreditReportModel();
                    armedForcesProofModel.fromDto(apiResult.payload);
                    let addressViewModel = new CreditReportViewModel(armedForcesProofModel);
                    const filtered = parent.creditReportViewModels.filter((a) => a.model.isDeleted == false);

                    runInAction(() => {
                        if (isDeleted) {
                            parent.creditReportViewModels = filtered;
                        } else {
                            parent.creditReportViewModels.push(addressViewModel);
                        }
                    });

                    parent.handleInputChange();

                    this.model.resetModel();
                    return Promise.resolve();
                } else {
                    console.error("CreditReport:Upsert-Error", apiResult.errors);
                    return Promise.reject(apiResult.errors);
                }
            }
        } catch (exception) {
            console.error(exception);
        } finally {
            this.saveStore.setIsSaving(false);
            this.setIsLoading(false);
        }
    };

    public async isFieldValid(fieldName: keyof FieldType<CreditReportModel>, value: any): Promise<boolean> {
        return await this.isValid(fieldName, value);
    }

    public async isValid(fieldName: keyof FieldType<CreditReportModel>, value: any, isRequired: boolean = false): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);
        // if (fieldName == "employerTelephone") {
        //     if (value && !validator.isEmpty(value)) {
        //         if (!validator.isMobilePhone(value)) {
        //             errorMessage = "Mobile telephone number is not valid";
        //             isValid = false;
        //         }
        //     }
        // }
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);
        return isValid;
    }

    /**
     * @returns boolean does this section have any errors
     */
    @action
    public async showUnfinishedFields(): Promise<boolean> {
        let hasError = false;
        for (const _field of Object.keys(this.model)) {
            let field = _field as keyof FieldType<CreditReportModel>;
            let value = this.model.getValue(field);
            let isRequired = true;
            let isValid = await this.isValid(field, value, isRequired);
            if (isValid == false) {
                hasError = true;
            }
        }
        return hasError;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
